// extracted by mini-css-extract-plugin
export default {"appBar":"src-feature-ui-__preview-file_appBar","iframePdf":"src-feature-ui-__preview-file_iframePdf","img":"src-feature-ui-__preview-file_img"};